/*
 * @Author: 李文 
 * @Date: 2020-10-31 10:08:58 
 * @Last Modified by: 李文
 */
import React from 'react';
import { Button, message, Table } from 'antd';
import { connect } from 'react-redux';
import drag from './images/drag.png';
import './index.scss';

class AddToEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: this.props.list,
            show: false
        }
    }

    getColumns = () => {
        const columns = [
            {
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 30,
                render: (record, text, index) => index + 1
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                render: (text, record) => <span className="column">{text}</span>
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                width: 50,
                render: (text, record) => {
                    let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
                    return <span style={{ cursor: 'pointer', color: newSecondSelectColor }} onClick={() => this.del(record)}>删除</span>
                }
            },
        ];
        return columns
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.parse(JSON.stringify(this.props.list)) !== JSON.parse(JSON.stringify(nextProps.list))) {
            console.log(nextProps.list)
            if (nextProps.list.length > 0) {
                this.setState({
                    show: true
                })
            }
            this.setState({
                listData: nextProps.list
            })
        }
    }

    handleShow = () => {
        //需要判断当前是否选择数据，选择数据再展开
        const { listData, show } = this.state;
        if (show) {
            this.setState({
                show: false
            })
        } else {
            if (listData.length === 0) {
                message.info('请点击拾取至合成器添加图文！');
                return;
            }
            this.setState({
                show: true
            })
        }
    }

    del = (record) => {
        //移除操作
        const { listData } = this.state;
        let resultData = listData.filter((item) => {
            return item.id !== record.id
        })
        this.props.changeList(resultData)
        if (resultData.length === 0) {
            this.setState({
                show: false
            })
        }
        this.setState({
            listData: resultData
        })
    }

    resetData = () => {
        this.props.changeList([])
        this.setState({
            listData: [],
            show: false
        })
    }

    goEdit = () => {
        this.props.submit(this.state.listData)

    }

    render() {
        const { show, listData } = this.state
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (
            <div className="add-to-editor">
                <div className="add-to-editor-title" onClick={this.handleShow}>
                    <span>图文合成器</span>
                    <div className="pic">
                        <img src={drag} alt="" />
                    </div>
                </div>
                <div className={`add-to-editor-wrap ${show ? 'show' : ''} `} >
                    <div className="add-to-editor-wrap-content">
                        {/* <Scrollbars style={{ height: 300}}> */}
                        <Table
                            className="add-to-editor-wrap-content-table"
                            dataSource={listData}
                            columns={this.getColumns()}
                            rowKey={(record) => record.id}
                            showHeader={false}
                            pagination={false}
                            bordered={true}
                            locale={{ emptyText: '' }}
                            scroll={{ y: '200px' }}
                        />
                        {/* </Scrollbars> */}
                    </div>
                    <div className="add-to-editor-wrap-footer">
                        <Button style={{ marginRight: 20 }} onClick={this.resetData}>清空</Button>
                        <Button onClick={this.goEdit} type="primary">拾取至编辑器</Button>
                    </div>
                </div>
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return{
        config : state.systemReducer.config
    }
}

export default connect(mapStateToProps)(AddToEditor)